/**
 * Cursor particle trail sitewide.
 * Uses theme image from window.__cursorTrailLightDepthChaos.particleSrc (set in Liquid).
 */
(function () {
  'use strict';

  var MAX_PARTICLES = 40;
  var MIN_SPAWN_MS = 28;
  var MIN_MOVE_PX = 5;
  var FALL_MIN = 96;
  var FALL_RANGE = 72;
  var DRIFT_RANGE = 52;

  /** Touch tap: how many particles spawn at once */
  var TOUCH_BURST_COUNT = 12;
  /** Max random offset from tap point (px), each axis */
  var TOUCH_BURST_JITTER = 32;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getParticleSrc() {
    var cfg = window.__cursorTrailLightDepthChaos;
    return cfg && typeof cfg.particleSrc === 'string' ? cfg.particleSrc : '';
  }

  function init() {
    if (prefersReducedMotion()) return;

    var particleSrc = getParticleSrc();
    if (!particleSrc) return;

    var container = document.createElement('div');
    container.id = 'cursor-particle-trail';
    container.setAttribute('aria-hidden', 'true');
    document.body.appendChild(container);

    var particles = [];
    var lastSpawn = 0;
    var lastX;
    var lastY;

    function trimOldest() {
      while (particles.length >= MAX_PARTICLES) {
        var first = particles.shift();
        if (first && first.parentNode) first.parentNode.removeChild(first);
      }
    }

    function spawn(clientX, clientY, jitter) {
      trimOldest();

      var j = jitter || 0;
      var x = clientX + (j ? (Math.random() - 0.5) * 2 * j : 0);
      var y = clientY + (j ? (Math.random() - 0.5) * 2 * j : 0);

      var el = document.createElement('div');
      el.className = 'cursor-particle-trail__particle';
      el.style.left = x + 'px';
      el.style.top = y + 'px';

      var drift = (Math.random() - 0.5) * DRIFT_RANGE;
      var fall = FALL_MIN + Math.random() * FALL_RANGE;
      var duration = 1 + Math.random() * 0.55;

      el.style.setProperty('--trail-drift-x', drift + 'px');
      el.style.setProperty('--trail-fall-y', fall + 'px');
      el.style.setProperty('--trail-dur', duration + 's');
      el.style.setProperty('--trail-rot', (Math.random() - 0.5) * 110 + 'deg');

      var img = document.createElement('img');
      img.className = 'cursor-particle-trail__img';
      img.src = particleSrc;
      img.alt = '';
      img.decoding = 'async';
      img.loading = 'eager';
      img.draggable = false;
      el.appendChild(img);

      el.addEventListener(
        'animationend',
        function onEnd() {
          el.removeEventListener('animationend', onEnd);
          var i = particles.indexOf(el);
          if (i !== -1) particles.splice(i, 1);
          if (el.parentNode) el.parentNode.removeChild(el);
        },
        false
      );

      container.appendChild(el);
      particles.push(el);
    }

    function spawnBurst(clientX, clientY) {
      var n = TOUCH_BURST_COUNT;
      for (var i = 0; i < n; i++) {
        spawn(clientX, clientY, TOUCH_BURST_JITTER);
      }
    }

    function onPointerMove(e) {
      if (!e || typeof e.clientX !== 'number') return;
      if (e.pointerType === 'touch') return;

      var now = performance.now();
      if (now - lastSpawn < MIN_SPAWN_MS) return;

      if (lastX !== undefined && lastY !== undefined) {
        var dx = e.clientX - lastX;
        var dy = e.clientY - lastY;
        if (dx * dx + dy * dy < MIN_MOVE_PX * MIN_MOVE_PX) return;
      }

      lastSpawn = now;
      lastX = e.clientX;
      lastY = e.clientY;
      spawn(e.clientX, e.clientY, 0);
    }

    function onPointerDown(e) {
      if (!e || typeof e.clientX !== 'number') return;
      if (e.pointerType !== 'touch') return;

      lastX = e.clientX;
      lastY = e.clientY;
      lastSpawn = performance.now();
      spawnBurst(e.clientX, e.clientY);
    }

    document.addEventListener('pointermove', onPointerMove, { passive: true });
    document.addEventListener('pointerdown', onPointerDown, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
